import {
  Autocomplete,
  Box,
  FormControl,
  Grid,
  Skeleton,
  TextField,
} from "@mui/material";
import React, { memo } from "react";

const KlasifikasiKecelakaan = ({
  input,
  setInput,
  loading,
  readOnly = false,
}) => {
  // Void functions
  const onChange = (item, value) => {
    let newList = [...input.detailKlasifikasiKecelakaanTrans];
    if (!value) {
      newList[item.headerId - 1].valueId = 0;
      newList[item.headerId - 1].valueName = "";
    } else {
      newList[item.headerId - 1].valueId = value.valueId;
      newList[item.headerId - 1].valueName = value.valueName;
    }

    setInput((prev) => ({
      ...prev,
      detailKlasifikasiKecelakaanTrans: newList,
    }));
  };

  if (loading) {
    return (
      <Box sx={styles.container}>
        <h3>Detail Klasifikasi Kecelakaan Transportasi</h3>
        <Grid container gap={1}>
          <Grid container item>
            <Grid item xl={3} lg={4} sm={12} xs={12}>
              <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
            </Grid>

            <Grid item xl={4} lg={5} sm={12} xs={12}>
              <FormControl fullWidth>
                <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    );
  }

  return (
    <>
      <Box sx={styles.container}>
        <h3>Detail Klasifikasi Kecelakaan Transportasi</h3>
        <Grid container gap={1}>
          {input.detailKlasifikasiKecelakaanTrans.map((item, idx) => (
            <Grid container item key={idx}>
              <Grid item xl={3} lg={4} sm={12} xs={12}>
                <h4>{item.headerName}</h4>
              </Grid>

              <Grid item xl={4} lg={5} sm={12} xs={12}>
                <FormControl fullWidth>
                  <Autocomplete
                    onChange={(e, value) => onChange(item, value)}
                    required
                    getOptionLabel={(option) => option.valueName}
                    options={item.detailValues}
                    value={{ valueId: item.valueId, valueName: item.valueName }}
                    isOptionEqualToValue={(o, v) => o.valueId == v.valueId}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={`Choose ${item.headerName}`}
                      />
                    )}
                    disabled={readOnly}
                  />
                </FormControl>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

const styles = {
  container: {
    px: 5,
    mt: 3,
    pt: 1,
    pb: 5,
    borderRadius: 3,
    display: "block",
    backgroundColor: "#fff",
  },
  field: {
    border: 1,
    borderColor: "lightgrey",
    px: 3,
    py: 2,
    borderRadius: 3,
    display: "block",
    backgroundColor: "#fff",
  },
};
export default memo(KlasifikasiKecelakaan);
